<template>
    <div>
      	<apexchart type="heatmap" :height="graphHeight" :options="chartOptions" :series="chartSeries" />
    </div>
</template>

<script>
import apexchart from 'vue-apexcharts'

export default {
	components: {
		apexchart
	},
    computed: {
        chartOptions()  {
            return  {
                xaxis: {
                    type: 'categories',
                    categories: this.categories,
                    title: {
                        text: 'Semana de alojamento'
                    },
                },
                plotOptions: {
                    heatmap: {
                        distributed: true,
                        max: this.chartMax
                    }
                },
                dataLabels: {
                    enabled: false
                },
                colors: ["#ff0000"],
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + '%'
                        }
                    }
                }
            }
        },
        chartSeries() {
            return this.values
        },
	    chartLabels() {
            return this.values.map(v => v.name)
        },
        chartMax() {
            return Math.max(...this.values.map(v => v.max))
        },
    },
	props: {
		values: Array,
        categories: Array,
        graphHeight: {
		    type: Number,
            default: 600
        }
	}
}

</script>


